/* LUVEA — L'ATELIER v4.0 (V20 DIY) : composeur en assistant, une étape à la fois.
   Flux : bijou → chaîne → fermoir → charms. Finition Or par défaut,
   changeable à tout moment via la ligne « Finition » du résumé (tap = bascule).
   Tout l'affichage est filtré par la finition choisie (Or/Argent) ; en changer
   remappe la chaîne, le fermoir et les charms quand l'équivalent existe.
   Données : lv-at-core.json (cdn, chaines, fermoirs) + lv-at-d0..d6.json
   (charms compacts, reconstruits par fusionner()).
   Règles maison : pas de MutationObserver, aucune dépendance externe. */
(function () {
  var root = document.getElementById('lv-at');
  if (!root || root.dataset.lvBound) { return; }
  root.dataset.lvBound = '1';
  var MAX = parseInt(root.dataset.max, 10) || 8;
  var D = null;
  var FX = {};
  function refOf() {
    for (var a = 0; a < arguments.length; a++) {
      var toks = String(arguments[a] || '').toUpperCase().match(/[A-Z]+\d+/g) || [];
      for (var i = 0; i < toks.length; i++) { if (FX[toks[i]]) { return toks[i]; } }
    }
    return null;
  }
  /* ferm : undefined = pas encore choisi · null = sans fermoir · {u,lblBase,pimg} */
  var st = { type: null, fin: 'Or', chP: null, chU: null, chV: null, ferm: undefined, charms: [] };

  /* galerie selon la finition : classement par le nom de fichier.
     argent/silver -> Argent, gold / -or- -> Or, photos portees et
     neutres (sans marqueur) affichees pour les deux finitions. */
  function galFin(g, fin) {
    var ag = /silver|argent/i, dor = /gold|[-_]or([-_.])/i;
    return (g || []).filter(function (x) {
      if (x.indexOf('-porte-') > -1) { return true; }
      return fin === 'Or' ? !ag.test(x) : !dor.test(x);
    });
  }

  /* vignettes de categories choisies dans l'editeur (blocs « Image de
     categorie ») : nom affiché -> URL. Sans bloc, photo du 1er charm. */
  var COVERS = {};
  function normNom(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); }
  document.querySelectorAll('.lv-at-cov').forEach(function (e) { COVERS[normNom(e.dataset.n)] = e.dataset.img; });
  /* montages 3x3 generes par finition (fichiers Shopify lv-cat-*.jpg) :
     vignettes par defaut des categories — un charm par sous-categorie,
     jamais de melange or/argent. Un bloc editeur (COVERS) reste prioritaire. */
  var CDNF = 'https://cdn.shopify.com/s/files/1/0775/4209/7228/files/';
  var DEF_COVS = {
    'pierres de naissance': 'lv-cat-pierres-de-naissance',
    'lettres & chiffres': 'lv-cat-lettres-chiffres',
    'zodiaque': 'lv-cat-zodiaque',
    'amour & cœurs': 'lv-cat-amour-c-urs',
    'celeste': 'lv-cat-celeste',
    'nature & animaux': 'lv-cat-nature-animaux',
    'symboles & protection': 'lv-cat-symboles-protection',
    'fetes & occasions': 'lv-cat-fetes-occasions:orSeul',
    'accessoires & style': 'lv-cat-accessoires-style'
  };
  function covDe(label, secours) {
    var k = normNom(label);
    if (COVERS[k]) { return COVERS[k]; }
    var d = DEF_COVS[k];
    if (!d) { return secours; }
    var orSeul = d.indexOf(':orSeul') > -1;
    var base = d.replace(':orSeul', '');
    var fin = (st.fin === 'Argent' && !orSeul) ? 'argent' : 'or';
    /* v= : cache-buster, a incrementer si les montages sont regeneres */
    return CDNF + base + '-' + fin + '.jpg?v=20260801b';
  }

  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function prix(v) { return (v.cap && v.cap > v.px) ? '<s style="color:#a8a096;font-weight:400;margin-right:5px">' + eur(v.cap) + '</s>' + eur(v.px) : eur(v.px); }
  function img(u) { return u ? (u.indexOf('http') === 0 ? u : D.cdn + u) : null; }
  function el(h) { var d = document.createElement('div'); d.innerHTML = h; return d.firstElementChild; }
  function metalDe(v) {
    if (v === 'Or' || v === 'Argent' || v === 'Or Rosé') { return v; }
    var m = /(?:·|-)\s*(Or Rosé|Or|Argent)\s*$/.exec(v || '');
    return m ? m[1] : null;
  }
  function sansMetal(v) { return (v || '').replace(/\s*(?:·|-)\s*(Or Rosé|Or|Argent)\s*$/, '').replace(/^(Or Rosé|Or|Argent)$/, '').trim(); }
  function unites(p) {
    var map = {}, ordre = [];
    p.vars.forEach(function (v) {
      var parts = v.o.map(sansMetal).filter(Boolean);
      var met = null;
      v.o.forEach(function (val) { var m = metalDe(val); if (m) { met = m; } });
      var key = parts.join('|') || '—';
      if (!map[key]) { map[key] = { label: parts.join(' · '), byFin: {}, ordre: ordre.length }; ordre.push(key); }
      map[key].byFin[met || '*'] = v;
    });
    return ordre.map(function (k) { return map[k]; });
  }
  function enFin(u, f) { return u.byFin[f] || u.byFin['*'] || null; }
  function choisirVar(u) { return enFin(u, st.fin) || u.byFin['Or'] || u.byFin['Argent'] || u.byFin['Or Rosé'] || null; }

  /* ---------- variantes effectives (suivent la finition courante) ---------- */
  function fermEff() {
    if (!st.ferm) { return st.ferm; } /* undefined ou null */
    var v = enFin(st.ferm.u, st.fin) || choisirVar(st.ferm.u);
    if (!v) { return null; }
    var met = null; v.o.forEach(function (val) { var m = metalDe(val); if (m) { met = m; } });
    return { v: v, lbl: st.ferm.lblBase + (met && met !== st.fin ? ' · ' + met : ''), img: img(v.img || st.ferm.pimg) };
  }
  function charmEff(c) {
    var v = enFin(c.u, st.fin) || enFin(c.u, c.fin) || c.u.byFin[Object.keys(c.u.byFin)[0]];
    var met = null; v.o.forEach(function (val) { var m = metalDe(val); if (m) { met = m; } });
    return { v: v, lbl: c.base + (met ? ' · ' + met : ''), img: img(v.img || c.pimg) };
  }
  function totalCourant() {
    if (st.type === 'charms') {
      if (!st.charms.length) { return null; }
      var tc = 0;
      st.charms.forEach(function (c) { tc += charmEff(c).v.px; });
      return tc;
    }
    if (!st.chV) { return null; }
    var t = st.chV.px;
    var fe = fermEff(); if (fe) { t += fe.v.px; }
    st.charms.forEach(function (c) { t += charmEff(c).v.px; });
    return t;
  }

  /* ---------- moteur d'étapes ---------- */
  var TITRES = { type: 'Votre bijou', chaine: 'Votre chaîne', fermoir: 'Votre fermoir', charms: 'Vos charms' };
  var PANELS = { type: 'p-type', chaine: 'p-chaine', fermoir: 'p-fermoir', charms: 'p-charms' };
  var cur = 'type';
  function etapes() {
    /* mode « charms seuls » : deux ecrans, pas de chaine ni fermoir */
    if (st.type === 'charms') { return ['type', 'charms']; }
    var a = ['type', 'chaine'];
    if (!(st.chP && st.chP.fermoir === 'inclus')) { a.push('fermoir'); }
    a.push('charms');
    return a;
  }
  function aller(k) {
    cur = k;
    if (typeof fermerSteps === 'function') { fermerSteps(); }
    if (k === 'chaine') { rendChProds(); rendChVars(); }
    if (k === 'fermoir') { rendFermoir(); }
    if (k === 'charms') { rendCharms(); rendCompo(); }
    majUI();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  function suivant() { var a = etapes(), i = a.indexOf(cur); if (i > -1 && i < a.length - 1) { aller(a[i + 1]); } }
  function precedent() {
    if (cur === 'charms' && vueFam !== null) { vueFam = null; rendCharms(); majUI(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    var a = etapes(), i = a.indexOf(cur); if (i > 0) { aller(a[i - 1]); }
  }
  document.getElementById('z-back').addEventListener('click', precedent);
  /* « Creer le mien » (sous les creations) : remonte aux panneaux */
  document.querySelectorAll('[data-lv-haut]').forEach(function (b) {
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  });

  /* ---------- menu des étapes (dropdown sous le fil d'ariane) ---------- */
  var NOMS_ET = { type: 'Bijou', chaine: 'Chaîne', fermoir: 'Fermoir', charms: 'Charms' };
  var stepsOuvert = false;
  function fermerSteps() {
    stepsOuvert = false;
    document.getElementById('z-steps').style.display = 'none';
    document.getElementById('z-cr-ch').style.transform = '';
  }
  document.getElementById('z-crumb').addEventListener('click', function () {
    stepsOuvert = !stepsOuvert;
    document.getElementById('z-steps').style.display = stepsOuvert ? 'block' : 'none';
    document.getElementById('z-cr-ch').style.transform = stepsOuvert ? 'rotate(180deg)' : '';
  });
  document.getElementById('z-fin').addEventListener('click', function () {
    poserFin(st.fin === 'Or' ? 'Argent' : 'Or');
  });
  function rendSteps(a, ci0) {
    var z = document.getElementById('z-steps'); z.innerHTML = '';
    a.forEach(function (k, i) {
      var done = i < ci0, cour = i === ci0;
      var b = el('<button type="button" class="lv-at-strow' + (cour ? ' cur' : '') + (i > ci0 ? ' off' : '') + '"><span class="k"></span><span class="v"></span></button>');
      b.querySelector('.k').textContent = (i + 1) + ' · ' + NOMS_ET[k];
      b.querySelector('.v').textContent = cour ? 'en cours' : (done && faite(k) ? libResume(k) + ' ✓' : '');
      if (done) { b.addEventListener('click', function () { fermerSteps(); aller(k); }); }
      z.appendChild(b);
    });
  }

  function faite(k) {
    if (k === 'type') { return !!st.type; }
    if (k === 'fin') { return !!st.fin; }
    if (k === 'chaine') { return !!st.chV; }
    if (k === 'fermoir') { return st.ferm !== undefined; }
    if (k === 'charms') { return st.charms.length > 0; }
    return false;
  }
  function libResume(k) {
    if (k === 'type') { return st.type === 'charms' ? 'Charms' : (st.type === 'collier' ? 'Collier' : 'Bracelet'); }
    if (k === 'fin') { return st.fin; }
    if (k === 'chaine') {
      var n = sansPrefixe(st.chP.t);
      var ul = st.chU ? sansTaille(st.chU.label) : '';
      return n + (ul ? ' · ' + ul : '');
    }
    if (k === 'fermoir') { var fe = fermEff(); return fe ? fe.lbl : 'Sans fermoir'; }
    return '';
  }

  function majUI() {
    var a = etapes();
    Object.keys(PANELS).forEach(function (k) {
      var p = document.getElementById(PANELS[k]);
      if (p) { p.classList.toggle('is-cur', k === cur); }
    });
    /* étape 1 = immersion totale : aucun habillage d'assistant, header du
       site en superposition transparente (html.lv-hero, voir lv-at.css) */
    var estHero = cur === 'type';
    root.classList.toggle('is-hero', estHero);
    document.documentElement.classList.toggle('lv-hero', estHero);
    if (!estHero) { document.body.classList.remove('lv-scrolled'); }
    var barEl = document.querySelector('.lv-at-bar');
    if (barEl) { barEl.style.display = estHero ? 'none' : ''; }
    /* contenu editorial sous les panneaux : etape 1 uniquement */
    var apEl = document.getElementById('z-apres');
    if (apEl) { apEl.style.display = estHero ? '' : 'none'; }
    document.querySelector('.lv-at-head').style.display = estHero ? 'none' : '';
    document.querySelector('.lv-at-prog').style.display = estHero ? 'none' : '';
    document.getElementById('z-sub').style.display = 'none'; /* les panneaux pleine page portent le texte */
    document.getElementById('z-back').style.visibility = (cur === 'type') ? 'hidden' : 'visible';
    /* fine ligne de progression */
    var ci0 = a.indexOf(cur);
    document.getElementById('z-prog').style.width = Math.round(((ci0 + 1) / a.length) * 100) + '%';
    /* fil d'ariane central : « Collier · 2/4 ⌄ » -> menu des étapes */
    document.getElementById('z-cr-t').textContent = st.type ? (st.type === 'charms' ? 'Charms' : (st.type === 'collier' ? 'Collier' : 'Bracelet')) : 'Votre bijou';
    document.getElementById('z-cr-n').textContent = (ci0 + 1) + '/' + a.length;
    /* pastille finition, toujours à un tap */
    document.getElementById('z-fin-p').className = 'disc ' + (st.fin === 'Or' ? 'd-or' : 'd-ag');
    document.getElementById('z-fin-l').textContent = st.fin;
    rendSteps(a, ci0);
    /* total + CTA */
    var tot = totalCourant();
    document.getElementById('z-total').textContent = tot === null ? '—' : eur(tot);
    var n = st.type === 'charms' ? st.charms.length : (st.chV ? 1 + (fermEff() ? 1 : 0) + st.charms.length : 0);
    document.getElementById('z-rec-n').textContent = n ? 'Ma création (' + n + ') ▴' : 'Voir ma création ▴';
    var cta = document.getElementById('z-cta');
    if (cur === 'type') { cta.disabled = true; cta.textContent = 'Choisissez votre bijou'; }
    else if (cur === 'chaine') {
      if (!st.chV) { cta.disabled = true; cta.textContent = 'Choisissez votre modèle'; }
      else { cta.disabled = false; cta.textContent = 'Continuer'; }
    }
    else if (cur === 'fermoir') {
      if (st.chP && st.chP.fermoir === 'requis' && !st.ferm) { cta.disabled = true; cta.textContent = 'Choisissez votre fermoir'; }
      else { cta.disabled = false; cta.textContent = 'Continuer'; }
    }
    else if (st.type === 'charms') {
      cta.disabled = !st.charms.length;
      cta.textContent = st.charms.length ? 'Ajouter au panier' : 'Choisissez vos charms';
    }
    else { cta.disabled = !st.chV; cta.textContent = 'Ajouter au panier'; }
    rendRecap();
  }

  /* ---------- étape : bijou — panneaux pleine hauteur empilés, effet
     « rideau » : le panneau Collier reste épinglé (sticky) pendant que le
     panneau Bracelet glisse PAR-DESSUS au scroll ; le panneau couvert zoome
     légèrement et s'assombrit, les textes montent en fondu. Aucun habillage
     d'assistant sur cette étape (masqué par majUI).
     Visuels/phrases personnalisables dans l'editeur de theme (data-hero-*). ---------- */
  function rendType() {
    var z = document.getElementById('z-type'); z.innerHTML = '';
    var DEF = {
      collier: { l: 'Collier', img: 'collier-perles-eau-douce-marea-YP15530-porte-2.jpg', txt: 'Une chaîne, un fermoir, vos charms — à votre façon.', cta: 'Créer mon collier' },
      bracelet: { l: 'Bracelet', img: 'bracelet-maille-trombone-tessia-YS49750-porte-1.jpg', txt: 'La parure assortie de votre collier, ou une pièce à part entière.', cta: 'Créer mon bracelet' },
      charms: { l: 'Charms', img: 'collier-nacree-trombone-solena-YP15533-porte-1.jpg', txt: 'Nos charms à l’unité — à offrir, ou pour enrichir vos bijoux.', cta: 'Choisir mes charms' }
    };
    var hero = el('<div class="lv-at-hero"></div>');
    var slides = [];
    [{ k: 'collier' }, { k: 'bracelet' }, { k: 'charms' }].forEach(function (t) {
      var prods = D.chaines[t.k] || [];
      if (t.k !== 'charms' && !prods.length) { return; }
      var d = DEF[t.k];
      /* visuels mobile / desktop separes (editeur de theme) ;
         si une version manque, l'autre sert de repli */
      var ds = root.dataset;
      var capM = (t.k === 'collier' ? ds.heroCollier : t.k === 'bracelet' ? ds.heroBracelet : ds.heroCharms) || '';
      var capD = (t.k === 'collier' ? ds.heroCollierDt : t.k === 'bracelet' ? ds.heroBraceletDt : ds.heroCharmsDt) || '';
      var vidM = (t.k === 'collier' ? ds.heroCollierVideo : t.k === 'bracelet' ? ds.heroBraceletVideo : ds.heroCharmsVideo) || '';
      var vidD = (t.k === 'collier' ? ds.heroCollierVideoDt : t.k === 'bracelet' ? ds.heroBraceletVideoDt : ds.heroCharmsVideoDt) || '';
      var txt = (t.k === 'collier' ? ds.heroCollierTxt : t.k === 'bracelet' ? ds.heroBraceletTxt : ds.heroCharmsTxt) || d.txt;
      var defSrc = img(d.img);
      var srcM = capM || capD || defSrc;
      var srcD = capD || capM || defSrc;
      var isDt = window.matchMedia && window.matchMedia('(min-width:900px)').matches;
      /* video : desktop prefere sa version puis celle du mobile */
      var vid = isDt ? (vidD || vidM) : vidM;
      var media = vid
        ? '<video src="' + vid + '" autoplay muted loop playsinline></video>'
        : (srcD !== srcM
          ? '<picture><source media="(min-width:900px)" srcset="' + srcD + '"><img alt="' + d.l + '" src="' + srcM + '"></picture>'
          : '<img alt="' + d.l + '" src="' + srcM + '">');
      /* deux blocs positionnables separement (editeur de theme) :
         titre (L'Atelier + nom) et texte + bouton */
      var posT = root.dataset.heroPosTitre || 'haut';
      var posX = root.dataset.heroPosTexte || 'bas';
      var posTd = root.dataset.heroPosTitreDt || 'centre';
      var posXd = root.dataset.heroPosTexteDt || 'bas';
      /* meme position pour les deux blocs : ils s'empilent (titre au-dessus)
         au lieu de se chevaucher — ca/cb en mobile, cad/cbd en desktop */
      var colM = posT === posX, colD = posTd === posXd;
      var s = el('<button type="button" class="lv-at-slide"><span class="med">' + media + '</span>' +
        '<span class="ov"></span><span class="sh"></span>' +
        '<span class="blk pos-' + posT + ' posd-' + posTd + (colM ? ' ca' : '') + (colD ? ' cad' : '') + '"><i class="k">L&rsquo;Atelier</i><b>' + d.l + '</b></span>' +
        '<span class="blk pos-' + posX + ' posd-' + posXd + (colM ? ' cb' : '') + (colD ? ' cbd' : '') + '"><small></small><span class="cta">' + d.cta + '</span></span></button>');
      s.querySelector('small').textContent = txt;
      s.addEventListener('click', function () {
        if (st.type !== t.k) { st.type = t.k; st.chP = null; st.chU = null; st.chV = null; st.ferm = undefined; }
        window.scrollTo(0, 0);
        aller(t.k === 'charms' ? 'charms' : 'chaine');
      });
      hero.appendChild(s);
      slides.push(s);
    });
    z.appendChild(hero);
    /* textes du 1er panneau : entrée en fondu au chargement */
    setTimeout(function () {
      if (slides[0]) { slides[0].querySelectorAll('.blk').forEach(function (b) { b.classList.add('vis'); }); }
    }, 150);
    /* effet au scroll : progression p = recouvrement du panneau 1 par le 2.
       Calcul dans un requestAnimationFrame, SANS transitions CSS sur le zoom
       et le voile : ce sont elles qui faisaient scintiller l'iPhone. */
    var rafId = 0;
    var calc = function () {
      rafId = 0;
      if (!document.body.contains(hero)) { window.removeEventListener('scroll', surScroll); return; }
      if (cur !== 'type' || !slides.length) { return; }
      /* meme mecanique que l'accueil : passe 30px, le header redevient blanc */
      document.body.classList.toggle('lv-scrolled', (window.scrollY || 0) > 30);
      var r = hero.getBoundingClientRect();
      var h = slides[0].offsetHeight || 1;
      /* progression globale : 0 -> N-1 panneaux recouverts */
      var pt = Math.min(slides.length - 1, Math.max(0, -r.top / h));
      slides.forEach(function (s2, i) {
        if (i < slides.length - 1) {
          var p = Math.min(1, Math.max(0, pt - i));
          var im = s2.querySelector('.med img, .med video');
          if (im) { im.style.transform = 'translateZ(0) scale(' + (1 + p * 0.06).toFixed(4) + ')'; }
          var sh = s2.querySelector('.sh');
          if (sh) { sh.style.opacity = (p * 0.45).toFixed(3); }
        }
        /* textes : visibles quand le panneau occupe l'ecran, fondu sinon */
        var vis = pt > i - 0.75 && pt < i + 0.22;
        s2.querySelectorAll('.blk').forEach(function (b) { b.classList.toggle('vis', vis); });
      });
    };
    var surScroll = function () { if (!rafId) { rafId = requestAnimationFrame(calc); } };
    window.addEventListener('scroll', surScroll, { passive: true });
    surScroll();
  }

  /* ---------- finition : Or par défaut, bascule depuis la ligne du résumé ---------- */
  function poserFin(f) {
    if (st.fin === f) { return; }
    st.fin = f;
    /* remappe la chaîne si l'équivalent existe dans la nouvelle finition */
    if (st.chU) { var nv = enFin(st.chU, f); if (nv) { st.chV = nv; } }
    if (cur === 'chaine') { rendChProds(); rendChVars(); }
    if (cur === 'fermoir') { rendFermoir(); }
    if (cur === 'charms') { rendCharms(); rendCompo(); }
    majUI();
  }
  /* ---------- étape : chaîne (grille directe des modèles) ---------- */
  function chDispo(p) {
    return unites(p).some(function (u) { return !!enFin(u, st.fin); });
  }
  var RX_TAILLE = /\s*·?\s*\d+(?:[.,]\d+)?\s*cm\s*\+\s*\d+(?:[.,]\d+)?\s*cm\s*/i;
  function sansTaille(l) { return (l || '').replace(RX_TAILLE, '').replace(/\s*·\s*$/, '').replace(/^\s*·\s*/, '').trim(); }
  /* « Collier Maille Forçat Fiora » ou « Chaîne Bracelet — X » -> nom court */
  function sansPrefixe(t) { return (t || '').replace(/^(?:Chaîne )?(?:Collier|Bracelet)(?: —)?\s*/, '').trim(); }
  function tailleDe(p) {
    var t = null;
    p.vars.some(function (v) { return v.o.some(function (o) { var m = /(\d+(?:[.,]\d+)?\s*cm\s*\+\s*\d+(?:[.,]\d+)?\s*cm)/i.exec(o); if (m) { t = m[1]; return true; } return false; }); });
    return t;
  }
  function rendChProds() { document.getElementById('z-chprod').innerHTML = ''; }
  function rendChVars() {
    var z = document.getElementById('z-chvar'); z.innerHTML = '';
    var prods = (D.chaines[st.type] || []).filter(chDispo);
    if (!prods.length) {
      z.appendChild(el('<p class="lv-at-note">Aucune chaîne en finition ' + st.fin + ' pour le moment — essayez l&rsquo;autre finition.</p>'));
      return;
    }
    /* taille : toutes les chaînes d'un type partagent la même (40+5 collier,
       15+3 bracelet) — affichée une fois à côté du titre */
    var tCommune = st.type === 'collier' ? '40 cm + 5 cm' : '15 cm + 3 cm';
    var head = el('<div class="lv-at-ssec lv-at-ssec-row"><span>Choisissez votre modèle</span><span class="sz">Taille unique · ' + tCommune + '</span></div>');
    z.appendChild(head);
    function tuile(p, u, v, label, ficheFn) {
      var im = v.img || p.img;
      var t = el('<button type="button" class="lv-at-tile">' + (im ? '<img alt="" loading="lazy">' : '<span class="ph">LUVEA</span>') + '<span class="t"></span><span class="p">' + prix(v) + '</span></button>');
      if (im) { t.querySelector('img').src = img(im); }
      t.querySelector('.t').textContent = label;
      boutonFiche(t, ficheFn);
      if (!v.ok) { t.style.opacity = .35; }
      t.addEventListener('click', function () {
        if (!v.ok) { return; }
        st.chP = p; st.chU = u; st.chV = v; st.ferm = undefined;
        z.querySelectorAll('.lv-at-tile').forEach(function (x) { x.classList.toggle('is-on', x === t); });
        majUI();
        setTimeout(function () { suivant(); }, 150);
      });
      if (st.chU === u) { t.classList.add('is-on'); }
      return t;
    }
    /* un produit = un modèle (galerie complète dans la fiche) -> une seule
       grille ; anciens produits multi-modèles -> sous-titre + grille dédiée */
    var solos = [], multis = [];
    prods.forEach(function (p) {
      var us = unites(p).filter(function (u) { return !!enFin(u, st.fin); });
      if (!us.length) { return; }
      if (us.length === 1 && !sansTaille(us[0].label)) { solos.push({ p: p, u: us[0] }); }
      else { multis.push({ p: p, us: us }); }
    });
    /* un produit = un modèle : GRANDE carte pleine largeur, galerie photos
       à faire défiler (points), nom + prix, « Choisir », détails en accordéon */
    if (solos.length) {
      var liste = el('<div class="lv-at-liste"></div>');
      solos.forEach(function (s) {
        var v = enFin(s.u, st.fin);
        var nomP = sansPrefixe(s.p.t);
        var ix = nomP.lastIndexOf(' ');
        var desc = ix > 0 ? nomP.slice(0, ix) : nomP;
        var pren = ix > 0 ? nomP.slice(ix + 1) : '';
        var c = el('<div class="lv-at-mcard">' +
          '<div class="galw"><div class="gal"></div><div class="dots"></div></div>' +
          '<div class="lig"><div class="nm"><span class="d1"></span><span class="l2"><b class="d2"></b><button type="button" class="det">Détails <i>⌄</i></button></span></div>' +
          '<button type="button" class="go"></button></div>' +
          '<div class="fiche" style="display:none"></div></div>');
        var gal = c.querySelector('.gal');
        var dots = c.querySelector('.dots');
        /* galerie selon la FINITION : visuel de la finition en tete,
           visuels de l'autre metal exclus, photos portees conservees */
        var v0c = v.img || s.p.img;
        var imgs = [v0c].concat(galFin(s.p.g, st.fin).filter(function (u) { return u !== v0c; })).slice(0, 6);
        if (!imgs.length) { imgs = [s.p.img]; }
        imgs.forEach(function (u, i2) {
          var im = el('<img alt="" loading="lazy">'); im.src = img(u); gal.appendChild(im);
          dots.appendChild(el('<i' + (i2 === 0 ? ' class="on"' : '') + '></i>'));
        });
        gal.addEventListener('scroll', function () {
          var i2 = Math.round(gal.scrollLeft / gal.clientWidth);
          dots.querySelectorAll('i').forEach(function (d, x) { d.classList.toggle('on', x === i2); });
        }, { passive: true });
        c.querySelector('.d1').textContent = desc;
        c.querySelector('.d2').textContent = pren;
        /* le prix vit dans le bouton (avec prix barré si promo) */
        c.querySelector('.go').innerHTML = 'Choisir&nbsp;·&nbsp;' + prix(v);
        var choisir = function () {
          var vv = enFin(s.u, st.fin); if (!vv || !vv.ok) { return; }
          st.chP = s.p; st.chU = s.u; st.chV = vv; st.ferm = undefined;
          z.querySelectorAll('.lv-at-mcard').forEach(function (x) { x.classList.toggle('is-on', x === c); });
          majUI();
          setTimeout(function () { suivant(); }, 150);
        };
        c.querySelector('.go').addEventListener('click', choisir);
        gal.addEventListener('click', choisir);
        var det = c.querySelector('.det');
        var fiche = c.querySelector('.fiche');
        det.addEventListener('click', function () {
          if (!fiche.childNodes.length) {
            lignesFX(refOf(v.img, s.p.img), null, st.fin).forEach(function (r) {
              var d = el('<div class="lv-at-frow"><span class="k"></span><span class="v"></span></div>');
              d.querySelector('.k').textContent = r[0];
              d.querySelector('.v').textContent = r[1];
              fiche.appendChild(d);
            });
            ajouteReassurance(fiche);
          }
          var ouvert = fiche.style.display !== 'none';
          fiche.style.display = ouvert ? 'none' : 'block';
          det.querySelector('i').style.transform = ouvert ? '' : 'rotate(180deg)';
        });
        if (st.chU === s.u) { c.classList.add('is-on'); }
        liste.appendChild(c);
      });
      z.appendChild(liste);
    }
    multis.forEach(function (m) {
      var nomP = sansPrefixe(m.p.t);
      if (multis.length > 1 || solos.length) {
        z.appendChild(el('<div class="lv-at-ssec2"></div>')).textContent = nomP;
      }
      var g = el('<div class="lv-at-grid3"></div>');
      m.us.forEach(function (u) {
        var v = enFin(u, st.fin); if (!v) { return; }
        g.appendChild(tuile(m.p, u, v, sansTaille(u.label) || 'Modèle unique', function () {
          var vv = enFin(u, st.fin) || v;
          var autre = u.byFin[st.fin === 'Or' ? 'Argent' : 'Or'];
          return { titre: 'Chaîne — ' + nomP, sous: (sansTaille(u.label) || 'Modèle unique') + ' · ' + st.fin, px: prix(vv), imgs: [img(vv.img || m.p.img), autre ? img(autre.img) : null, img(m.p.img)], ref: refOf(vv.img, m.p.img) };
        }));
      });
      z.appendChild(g);
    });
  }

  /* ---------- étape : fermoir — meme langage que les cartes chaines :
     sans bordure, photo carree (galerie a traits si plusieurs visuels),
     nom deux lignes + Détails inline, dims discretes, bouton prix.
     Deux par ligne ; « Détails » ouvre un panneau pleine largeur
     sous la rangee concernee ---------- */
  function rendFermoir() {
    var z = document.getElementById('z-fermoir'); z.innerHTML = '';
    if (!st.chP || st.chP.fermoir === 'inclus') { return; }
    var g = el('<div class="lv-at-grid2"></div>');
    var panneau = el('<div class="lv-at-detrow" style="display:none"></div>');
    var panneauPour = null;
    var cartes = [];
    function fermerPanneau() {
      panneau.style.display = 'none'; panneauPour = null;
      g.classList.remove('lv-det-open');
      g.querySelectorAll('.is-det').forEach(function (x) { x.classList.remove('is-det'); });
    }
    D.fermoirs.forEach(function (p) {
      unites(p).forEach(function (u) {
        var v = enFin(u, st.fin); if (!v) { return; }
        var nom = p.t.replace(/^Fermoir —\s*/, '') + (u.label ? ' · ' + u.label : '');
        var ix = nom.lastIndexOf(' · ');
        var d1 = ix > 0 ? nom.slice(0, ix) : nom;
        var d2 = ix > 0 ? nom.slice(ix + 3) : '';
        var dims = v.d || p.d;
        var c = el('<div class="lv-at-fcard">' +
          '<div class="galw"><div class="gal"></div><div class="dots"></div><button type="button" class="det">Détails</button></div>' +
          '<span class="d1"></span>' +
          '<span class="l2"><b class="d2"></b></span>' +
          (dims ? '<span class="dd">≈ ' + dims + '</span>' : '') +
          '<button type="button" class="go"></button></div>');
        var gal = c.querySelector('.gal');
        var dots = c.querySelector('.dots');
        /* galerie selon la finition (memes suffixes que les chaines) */
        var v0f = v.img || p.img;
        var imgs = [v0f].concat(galFin(p.g, st.fin).filter(function (x) { return x !== v0f; })).slice(0, 6);
        imgs.forEach(function (uimg, i2) {
          var im = el('<img alt="" loading="lazy">'); im.src = img(uimg); gal.appendChild(im);
          if (imgs.length > 1) { dots.appendChild(el('<i' + (i2 === 0 ? ' class="on"' : '') + '></i>')); }
        });
        if (imgs.length > 1) {
          gal.addEventListener('scroll', function () {
            var i2 = Math.round(gal.scrollLeft / gal.clientWidth);
            dots.querySelectorAll('i').forEach(function (dd, x) { dd.classList.toggle('on', x === i2); });
          }, { passive: true });
        }
        c.querySelector('.d1').textContent = d1;
        c.querySelector('.d2').textContent = d2;
        c.querySelector('.go').innerHTML = 'Choisir&nbsp;·&nbsp;' + prix(v);
        var choisir = function () {
          st.ferm = { u: u, lblBase: nom, pimg: p.img };
          g.querySelectorAll('.lv-at-fcard').forEach(function (x) { x.classList.toggle('is-on', x === c); });
          majUI();
          setTimeout(function () { suivant(); }, 150);
        };
        gal.addEventListener('click', choisir);
        c.querySelector('.go').addEventListener('click', choisir);
        c.querySelector('.det').addEventListener('click', function (ev) {
          ev.stopPropagation();
          if (panneauPour === c) { fermerPanneau(); return; }
          fermerPanneau();
          panneauPour = c;
          panneau.innerHTML = '';
          var ti = el('<div class="tt"></div>'); ti.textContent = nom; panneau.appendChild(ti);
          lignesFX(refOf(v.img, p.img), dims, st.fin).forEach(function (r) {
            var d = el('<div class="lv-at-frow"><span class="k"></span><span class="v"></span></div>');
            d.querySelector('.k').textContent = r[0];
            d.querySelector('.v').textContent = r[1];
            panneau.appendChild(d);
          });
          ajouteReassurance(panneau);
          var idx = cartes.indexOf(c);
          var finRangee = cartes[Math.min(cartes.length - 1, idx % 2 === 0 ? idx + 1 : idx)];
          g.insertBefore(panneau, finRangee.nextSibling);
          panneau.style.display = 'block';
          /* la carte regardee reste pleine, les autres s'estompent */
          g.classList.add('lv-det-open');
          c.classList.add('is-det');
        });
        if (st.ferm && st.ferm.u === u) { c.classList.add('is-on'); }
        cartes.push(c); g.appendChild(c);
      });
    });
    z.appendChild(g);
  }

  /* ---------- étape : charms ---------- */
  var vueFam = null;
  function compatible(p) { return (p.attache || 'boucle') === 'boucle'; }
  function famN(fam) {
    var n = 0;
    fam.produits.filter(compatible).forEach(function (p) { unites(p).forEach(function (u) { if (enFin(u, st.fin)) { n++; } }); });
    return n;
  }
  function rendCharms() {
    var z = document.getElementById('z-charms');
    if (!D || !D.familles) { return; }
    z.innerHTML = '';
    if (vueFam === null) {
      z.appendChild(el('<div class="lv-at-ssec">Choisissez votre style</div>'));
      /* categories : 2 colonnes mobile, 4 desktop, langage sans bordure */
      var g = el('<div class="lv-at-gridc"></div>');
      /* carte « Tous nos charms » : tout voir d'un seul scroll */
      var totN = 0, covers = [];
      D.familles.forEach(function (fam) {
        var n = famN(fam); totN += n;
        var prods = fam.produits.filter(compatible);
        var cv0 = COVERS[normNom(fam.label)] || (prods.length && prods[0].img);
        if (n && cv0 && covers.length < 4) { covers.push(cv0); }
      });
      /* vignette « Tous nos charms » : image dediee (remplacable via un bloc
         « Image de categorie » nomme Tous nos charms) ; mosaique en secours */
      var covAll = COVERS[normNom('Tous nos charms')] || 'https://cdn.shopify.com/s/files/1/0775/4209/7228/files/Tous-les-charms_Large_f003fa70-eb66-489a-85bd-a705ad739423.jpg?v=1785583515';
      var all = el('<button type="button" class="lv-at-ccard all"><span class="ph2"><img alt="" loading="lazy"></span><span class="t1">Tous nos charms</span><span class="t2">' + totN + ' charms</span></button>');
      all.querySelector('img').src = covAll;
      all.addEventListener('click', function () { vueFam = 'all'; rendCharms(); majUI(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
      D.familles.forEach(function (fam, fi) {
        var prods = fam.produits.filter(compatible);
        if (!prods.length) { return; }
        var n = famN(fam);
        if (!n) { return; }
        var cov = covDe(fam.label, prods[0].img);
        var c = el('<button type="button" class="lv-at-ccard"><span class="ph2">' + (cov ? '<img alt="" loading="lazy">' : '') + '</span><span class="t1"></span><span class="t2">' + n + ' charms</span></button>');
        if (cov) { c.querySelector('img').src = img(cov); }
        c.querySelector('.t1').textContent = fam.label;
        c.addEventListener('click', function () { vueFam = fi; rendCharms(); majUI(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
        g.appendChild(c);
      });
      /* « Tous nos charms » : banniere pleine largeur, en fin de grille */
      g.appendChild(all);
      z.appendChild(g);
      return;
    }
    var back = el('<button type="button" class="lv-at-back">‹ Tous les styles</button>');
    back.addEventListener('click', function () { vueFam = null; rendCharms(); majUI(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
    z.appendChild(back);
    var fams = (vueFam === 'all') ? D.familles.filter(function (f) { return famN(f) > 0; }) : [D.familles[vueFam]];
    fams.forEach(function (fam) { rendFam(fam, z); });
  }
  function rendFam(fam, z) {
    z.appendChild(el('<div class="lv-at-ssec">' + fam.label + '</div>'));
    fam.produits.filter(compatible).forEach(function (p) {
      var us = unites(p).filter(function (u) { return !!enFin(u, st.fin); });
      if (!us.length) { return; }
      var court = p.t.replace(/^Charm\s*/, '');
      /* nom du produit en NOIR : hierarchie claire sous la famille grise */
      z.appendChild(el('<div class="lv-at-ssec2">' + court + '</div>'));
      var g = el('<div class="lv-at-grid3"></div>');
      us.forEach(function (u) {
        var v = enFin(u, st.fin);
        var im = v.img || p.img;
        var dm = v.d || p.d;
        var t = el('<button type="button" class="lv-at-tile">' + (im ? '<img alt="" loading="lazy">' : '<span class="ph">LUVEA</span>') + '<span class="t"></span>' + (dm ? '<span class="d">≈ ' + dm + '</span>' : '') + '<span class="p">' + prix(v) + '</span></button>');
        if (im) { t.querySelector('img').src = img(im); }
        t.querySelector('.t').textContent = u.label || court;
        var ajouter = function () {
          var vv = enFin(u, st.fin) || v;
          if (!vv.ok || st.charms.length >= MAX) { return; }
          st.charms.push({ u: u, base: court + (u.label ? ' · ' + u.label : ''), fin: st.fin, pimg: p.img });
          rendCompo(); majUI(); majBadge(t);
        };
        boutonFiche(t, function () {
          var vv = enFin(u, st.fin) || v;
          var autre = u.byFin[st.fin === 'Or' ? 'Argent' : 'Or'];
          return { titre: court, sous: (u.label ? u.label + ' · ' : '') + st.fin, px: prix(vv), imgs: [img(vv.img || p.img), autre ? img(autre.img) : null], ref: refOf(vv.img, p.img, p.ip), dims: dm, add: ajouter };
        });
        if (!v.ok) { t.style.opacity = .35; }
        t.dataset.vids = Object.keys(u.byFin).map(function (k) { return u.byFin[k].id; }).join(',');
        majBadge(t);
        t.addEventListener('click', function () {
          ajouter();
          t.classList.add('is-add');
          setTimeout(function () { t.classList.remove('is-add'); }, 700);
        });
        g.appendChild(t);
      });
      z.appendChild(g);
    });
  }

  function compteUnite(idsStr) {
    var ids = (idsStr || '').split(',');
    var n = 0;
    st.charms.forEach(function (c) { if (ids.indexOf(String(charmEff(c).v.id)) > -1) { n++; } });
    return n;
  }
  function majBadge(t) {
    var n = compteUnite(t.dataset.vids);
    var b = t.querySelector('.qt');
    if (!n) { if (b) { b.remove(); } return; }
    if (!b) { b = document.createElement('span'); b.className = 'qt'; t.appendChild(b); }
    b.textContent = String(n);
  }

  /* ---------- composition (sans flèches : bijou DIY, l'ordre est libre) ---------- */
  function retirerCharm(i) { st.charms.splice(i, 1); rendCompo(); if (cur === 'charms') { rendCharms(); } majUI(); }
  function rendCompo() {
    var box = document.getElementById('z-compo');
    document.getElementById('t-compo').style.display = st.charms.length ? '' : 'none';
    box.innerHTML = '';
    st.charms.forEach(function (c, i) {
      var e = charmEff(c);
      var d = el('<div class="lv-at-chip"><button type="button" class="x" aria-label="Retirer">✕</button>' + (e.img ? '<img alt="">' : '') + '<span class="l"></span></div>');
      if (e.img) { d.querySelector('img').src = e.img; }
      d.querySelector('.l').textContent = e.lbl;
      d.querySelector('.x').addEventListener('click', function () { retirerCharm(i); });
      box.appendChild(d);
    });
  }

  /* ---------- récap sticky + fiche technique ---------- */
  var sheet = document.getElementById('z-sheet');
  var bd = document.getElementById('z-bd');
  var sheetMode = 'recap';
  function fermerRecap() {
    sheet.classList.remove('is-on'); sheet.classList.remove('is-fiche');
    bd.classList.remove('is-on'); sheetMode = 'recap';
    document.documentElement.classList.remove('lv-lock');
  }
  bd.addEventListener('click', fermerRecap);

  /* lignes de la fiche technique d'une ref (partagées : feuille + accordéons).
     Vocabulaire marketing : jamais « strass » (on dit zircons), et l'acier
     316L porte sa mention « grade médical ». */
  function polirValeur(v) {
    v = String(v).replace(/Strass/g, 'Zircons').replace(/strass/g, 'zircons');
    if (v.indexOf('316L') > -1 && v.indexOf('grade médical') === -1) {
      v = v.replace('316L', '316L · grade médical');
    }
    return v;
  }
  /* finition affichee dans les fiches : le vrai procede, pas juste « Or » */
  function libFinition(met) {
    if (met === 'Argent') { return 'Argenté'; }
    if (met === 'Or Rosé') { return 'Plaqué Or Rosé · PVD'; }
    return 'Plaqué Or 14 carats · PVD';
  }
  function lignesFX(ref, dims, met) {
    var fx = ref ? FX[ref] : null;
    var rows = [];
    if (fx && fx.r) { rows = fx.r.slice(); }
    else {
      if (dims) { rows.push(['Dimensions', '≈ ' + dims]); }
      if (fx && fx.e) { rows.push(['Épaisseur', fx.e]); }
      if (fx && fx.p) { rows.push(['Poids', fx.p + ' g']); }
      rows.push(['Matière', (fx && fx.m) ? fx.m : 'Acier inoxydable 316L']);
    }
    rows = rows.map(function (r) { return [r[0], polirValeur(r[1])]; });
    if (met) { rows.unshift(['Finition', libFinition(met)]); }
    return rows;
  }

  /* pierres de naissance : pierre + signification par mois */
  var BIRTH = {
    'janvier': ['Grenat', 'Représentant la passion et l’énergie.'],
    'fevrier': ['Améthyste', 'Cette pierre est associée à la royauté et la stabilité.'],
    'mars': ['Aigue-Marine', 'Symbole de sagesse et de dignité.'],
    'avril': ['Diamant', 'Symbole de clarté et de pureté.'],
    'mai': ['Émeraude', 'Représentant la renaissance et l’amour.'],
    'juin': ['Alexandrite', 'Cette pierre violette est souvent associée à la sagesse.'],
    'juillet': ['Rubis', 'Représentant l’amour et la compassion.'],
    'aout': ['Péridot', 'Cette pierre verte est souvent associée à la magie et à la guérison.'],
    'septembre': ['Saphir', 'Représentant la loyauté et la confiance.'],
    'octobre': ['Tourmaline Rose', 'Symbole d’espoir et de pureté.'],
    'novembre': ['Citrine', 'Elle est censée donner de l’inspiration et augmenter la richesse.'],
    'decembre': ['Topaze', 'Cette belle pierre bleu-vert est connue pour apporter la paix.']
  };
  function moisDe(txt) {
    var mots = normNom(txt).split(/[^a-z]+/);
    for (var i = 0; i < mots.length; i++) { if (BIRTH[mots[i]]) { return mots[i]; } }
    return null;
  }

  /* reassurance : partagee entre toutes les fiches (charms, chaines, fermoirs) */
  function ajouteReassurance(cont) {
    cont.appendChild(el('<div class="lv-at-sec"><span class="k">Hypoallergénique</span><small>Doux pour la peau, ne provoque pas d’irritations.</small></div>'));
    cont.appendChild(el('<div class="lv-at-sec"><span class="k">Waterproof</span><small>Ne ternit pas, ne noircit pas, ne déteint pas.</small></div>'));
    cont.appendChild(el('<div class="lv-at-sec"><span class="k">Pensé pour le quotidien</span><small>Douche, sport, plage, vous ne le quittez plus.</small></div>'));
  }

  /* fiche technique : petite feuille avec photos + détails */
  function ouvrirFiche(o) {
    sheetMode = 'fiche';
    sheet.innerHTML = '';
    var sh = el('<div class="sh"><span class="t"></span><button type="button" class="close">✕</button></div>');
    sh.querySelector('.t').textContent = o.titre || 'Détails';
    sh.querySelector('.close').addEventListener('click', fermerRecap);
    sheet.appendChild(sh);
    var imgs = (o.imgs || []).filter(function (x, i, a) { return x && a.indexOf(x) === i; });
    if (imgs.length) {
      var sc = el('<div class="lv-at-fimgs"></div>');
      imgs.forEach(function (u) { var im = el('<img alt="" loading="lazy">'); im.src = u; sc.appendChild(im); });
      sheet.appendChild(sc);
    }
    /* pierre de naissance : meme gabarit que les lignes techniques */
    var mois = moisDe((o.sous || '') + ' ' + (o.titre || ''));
    /* la ligne « Janvier · Or » ne se repete pas : le mois vit dans le bloc
       pierre de naissance, le metal dans la ligne Finition. On ne garde que
       ce qui n'apparait nulle part ailleurs (ex. la lettre d'une initiale). */
    var sousAff = mois ? '' : sansMetal(o.sous || '');
    var pxAff = o.add ? '' : (o.px || '');
    if (sousAff || pxAff) {
      var fh = el('<div class="lv-at-fhead"><span class="n"></span><span class="px"></span></div>');
      fh.querySelector('.n').textContent = sousAff;
      /* si la fiche porte une action, le prix vit dans le bouton */
      fh.querySelector('.px').innerHTML = pxAff;
      sheet.appendChild(fh);
    }
    if (mois) {
      var bi = BIRTH[mois];
      var AFF = { fevrier: 'Février', aout: 'Août', decembre: 'Décembre' };
      var moisAff = AFF[mois] || (mois.charAt(0).toUpperCase() + mois.slice(1));
      var bd2 = el('<div class="lv-at-sec"><span class="k">Pierre de naissance</span><span class="t"></span><small></small></div>');
      bd2.querySelector('.t').textContent = moisAff + ' · ' + bi[0];
      bd2.querySelector('small').textContent = bi[1];
      sheet.appendChild(bd2);
    }
    lignesFX(o.ref, o.dims, metalDe(o.sous || '') || st.fin).forEach(function (r) {
      var d = el('<div class="lv-at-frow"><span class="k"></span><span class="v"></span></div>');
      d.querySelector('.k').textContent = r[0];
      d.querySelector('.v').textContent = r[1];
      sheet.appendChild(d);
    });
    /* reassurance : memes lignes que le reste de la fiche, un seul langage */
    ajouteReassurance(sheet);
    /* action directe depuis la fiche (charms) */
    if (o.add) {
      var ab = el('<button type="button" class="lv-at-fadd"></button>');
      ab.innerHTML = 'Ajouter à ma création' + (o.px ? '&nbsp;·&nbsp;' + o.px : '');
      ab.addEventListener('click', function () { o.add(); fermerRecap(); });
      sheet.appendChild(ab);
    }
    sheet.classList.add('is-on'); sheet.classList.add('is-fiche'); bd.classList.add('is-on');
    sheet.scrollTop = 0;
    document.documentElement.classList.add('lv-lock');
  }
  function boutonFiche(t, o) {
    var fi = el('<span class="fi" role="button" aria-label="Fiche technique">Info</span>');
    fi.addEventListener('click', function (ev) { ev.stopPropagation(); ouvrirFiche(o()); });
    t.appendChild(fi);
  }
  function ligne(imgUrl, l, s, px, surX) {
    var d = el('<div class="lv-at-rl">' + (imgUrl ? '<img alt="">' : '') + '<div class="in"><div class="l"></div>' + (s ? '<div class="s"></div>' : '') + '</div><span class="px"></span>' + (surX ? '<button type="button" class="x">✕</button>' : '') + '</div>');
    if (imgUrl) { d.querySelector('img').src = imgUrl; }
    d.querySelector('.l').textContent = l;
    if (s) { d.querySelector('.s').textContent = s; }
    d.querySelector('.px').innerHTML = px;
    if (surX) { d.querySelector('.x').addEventListener('click', surX); }
    return d;
  }
  function rendRecap() {
    if (!sheet.classList.contains('is-on') || sheetMode !== 'recap') { return; }
    sheet.innerHTML = '';
    var sh = el('<div class="sh"><span class="t">Ma création</span><button type="button" class="close">✕</button></div>');
    sh.querySelector('.close').addEventListener('click', fermerRecap);
    sheet.appendChild(sh);
    if (st.type === 'charms') {
      if (!st.charms.length) {
        sheet.appendChild(el('<p class="lv-at-note">Choisissez vos charms pour commencer.</p>'));
        return;
      }
    } else {
      if (!st.chV) {
        sheet.appendChild(el('<p class="lv-at-note">Choisissez d&rsquo;abord votre bijou et votre chaîne.</p>'));
        return;
      }
      var typ = st.type === 'collier' ? 'Collier' : 'Bracelet';
      var nomCh = sansPrefixe(st.chP.t);
      var sousCh = (st.chU && sansTaille(st.chU.label) ? sansTaille(st.chU.label) + ' · ' : '') + st.fin;
      var tCh = tailleDe(st.chP) || (st.type === 'collier' ? '40 cm + 5 cm' : '15 cm + 3 cm'); sousCh += ' · ' + tCh;
      sheet.appendChild(ligne(img(st.chV.img || st.chP.img), typ + ' — ' + nomCh, sousCh, prix(st.chV)));
      if (st.chP.fermoir === 'inclus') { sheet.appendChild(ligne(null, 'Fermoir inclus', null, '')); }
      var fe = fermEff();
      if (fe) { sheet.appendChild(ligne(fe.img, 'Fermoir — ' + fe.lbl, null, prix(fe.v))); }
    }
    st.charms.forEach(function (c, i) {
      var e = charmEff(c);
      sheet.appendChild(ligne(e.img, e.lbl, null, prix(e.v), function () { retirerCharm(i); }));
    });
    sheet.appendChild(el('<div class="lv-at-rtot"><span>Total</span><span>' + eur(totalCourant()) + '</span></div>'));
    /* Les remises automatiques (2+1, 2eme a -50 %) sont calculees par Shopify
       sur le panier ENTIER : on ne les simule pas ici (on annoncerait un prix
       qu'on ne pourrait pas garantir), on previent simplement le client que le
       total va baisser au panier. Texte modifiable dans l'editeur. */
    /* Le delai d'assemblage, annonce AVANT l'ajout au panier : c'est le
       moment ou la question se pose vraiment. Meme ligne discrete que la
       mention promo, texte modifiable dans l'editeur. */
    var md = (root.dataset.delai || '').trim();
    if (md) {
      var pd = el('<p class="lv-at-rpromo"></p>');
      pd.textContent = md;
      sheet.appendChild(pd);
    }
    var mp = (root.dataset.promo || '').trim();
    if (mp) {
      var pp = el('<p class="lv-at-rpromo"></p>');
      pp.textContent = mp;
      sheet.appendChild(pp);
    }
    var add = el('<button type="button" class="lv-at-radd">Ajouter ma création au panier</button>');
    if (document.getElementById('z-cta').disabled || cur !== 'charms') { add.disabled = (cur !== 'charms' && !st.chV); }
    add.addEventListener('click', ajouterPanier);
    sheet.appendChild(add);
  }
  document.getElementById('z-rec').addEventListener('click', function () {
    sheetMode = 'recap'; sheet.classList.remove('is-fiche');
    sheet.classList.add('is-on'); bd.classList.add('is-on');
    document.documentElement.classList.add('lv-lock');
    rendRecap();
  });

  /* ---------- panier (branchement final à venir : composants pas encore publiés) ---------- */
  function ajouterPanier() {
    var solo = st.type === 'charms'; /* charms seuls : pas de composition */
    if (solo ? !st.charms.length : !st.chV) { return; }
    var cta = document.getElementById('z-cta');
    cta.disabled = true; cta.textContent = 'Ajout en cours…';
    var cid = 'LV' + Date.now().toString(36).toUpperCase();
    var items = [];
    if (!solo) {
      var typ = st.type === 'collier' ? 'Collier' : 'Bracelet';
      var fe = fermEff();
      /* resume lisible pour la COMMANDE (admin / preparation) */
      var resume = sansPrefixe(st.chP.t) + ' · ' + st.fin;
      if (st.chP.fermoir === 'inclus') { resume += ' • Fermoir inclus'; }
      if (fe) { resume += ' • Fermoir : ' + fe.lbl; }
      st.charms.forEach(function (c) { resume += ' • ' + charmEff(c).lbl; });
      items.push({
        id: st.chV.id, quantity: 1, properties: {
          '_lv_compo': cid, '_lv_role': 'chaine',
          '_lv_titre': typ + ' personnalisé',
          '_lv_fermoir': fe ? fe.lbl : (st.chP.fermoir === 'inclus' ? 'Inclus' : ''),
          'Composition': resume
        }
      });
      if (fe) { items.push({ id: fe.v.id, quantity: 1, properties: { '_lv_compo': cid, '_lv_role': 'fermoir' } }); }
    }
    var qte = {};
    st.charms.forEach(function (c) { var id = charmEff(c).v.id; qte[id] = (qte[id] || 0) + 1; });
    Object.keys(qte).forEach(function (vid) {
      items.push({ id: parseInt(vid, 10), quantity: qte[vid], properties: solo ? {} : { '_lv_compo': cid, '_lv_role': 'charm' } });
    });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) {
        if (!r.ok) { throw new Error('cart'); }
        cta.disabled = false; cta.textContent = 'Ajouter au panier';
        /* ouvre le tiroir panier (l'habillage y regroupe la creation) */
        var tb = document.querySelector('.minicart-btn');
        if (tb) { tb.click(); } else { window.location.href = '/cart'; }
      })
      .catch(function () {
        cta.disabled = false; cta.textContent = 'Ajouter au panier';
        var n = document.getElementById('z-cta-note');
        if (n) { n.textContent = "L'ajout au panier a échoué — réessayez dans un instant."; n.style.display = 'block'; setTimeout(function () { n.style.display = 'none'; }, 4000); }
      });
  }
  document.getElementById('z-cta').addEventListener('click', function () {
    if (cur === 'charms') { ajouterPanier(); } else { suivant(); }
  });

  /* ---------- données compactes -> familles ---------- */
  function fusionner(parts) {
    var fams = [], byKey = {};
    parts.forEach(function (part) {
      (part.f || []).forEach(function (fa) {
        var t = byKey[fa.key];
        if (!t) { t = { key: fa.key, label: fa.label, produits: [] }; byKey[fa.key] = t; fams.push(t); }
        fa.p.forEach(function (p) {
          var vars = [], last = '';
          p.v.forEach(function (e) {
            var rem = e[3], im;
            if (rem === '!') { im = null; }
            else if (rem === '=') { im = p.ip + last; }
            else { last = rem; im = p.ip + rem; }
            var v = { id: e[0], px: e[1] || p.pm, o: e[2].split('|'), img: im, ok: true };
            if (e.length > 4 && e[4]) { v.cap = e[4]; }
            if (e.length > 5 && e[5]) { v.d = e[5]; }
            vars.push(v);
          });
          t.produits.push({ t: p.t, img: p.img, attache: p.a, pxmin: p.pm, d: p.d, vars: vars });
        });
      });
    });
    return fams;
  }

  /* ---------- chargement ---------- */
  if (root.dataset.fx) {
    fetch(root.dataset.fx).then(function (r) { return r.json(); }).then(function (j) { FX = j || {}; }).catch(function () {});
  }
  var srcs = [root.dataset.core].concat((root.dataset.parts || '').split('|').filter(Boolean));
  Promise.all(srcs.map(function (u) { return fetch(u).then(function (r) { return r.json(); }); }))
    .then(function (parts) {
      var fams = fusionner(parts.slice(1));
      /* Fêtes & Occasions : saisonniere, toujours en fin de liste */
      for (var iF = 0; iF < fams.length; iF++) {
        if (fams[iF].label === 'Fêtes & Occasions') { fams.push(fams.splice(iF, 1)[0]); break; }
      }
      D = { cdn: parts[0].cdn, chaines: parts[0].chaines, fermoirs: parts[0].fermoirs, familles: fams };
      rendType(); majUI();
    })
    .catch(function () {
      document.getElementById('z-type').innerHTML = '<p class="lv-at-note">Le composeur n&rsquo;a pas pu charger ses données — rechargez la page.</p>';
    });
})();
